import { render, staticRenderFns } from "./SopCollapseFormItem.vue?vue&type=template&id=67e6c732&scoped=true&"
import script from "./SopCollapseFormItem.vue?vue&type=script&lang=js&"
export * from "./SopCollapseFormItem.vue?vue&type=script&lang=js&"
import style0 from "./SopCollapseFormItem.vue?vue&type=style&index=0&id=67e6c732&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e6c732",
  null
  
)

export default component.exports